export const dbCon = {
  methods: {
    db() {
      this.$confirm('提交后将无法更改', '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '返回',
        type: 'warning'
      })
        .then(() => {
          this.submitForm('ruleForm', 1);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    }
  },
  created() {}
};
